import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';

export interface CopilotImportPayload {
  project: { id: string };
}

const MUTATION = gql`
  mutation MaterializeCopilotImport($jobId: ID!) {
    materializeCopilotImport(jobId: $jobId) {
      project {
        id
      }
    }
  }
`;

export const materializeCopilotImport = async (jobId: string): Promise<CopilotImportPayload> => {
  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables: { jobId },
  });

  return getSingleProp(result.data) as CopilotImportPayload;
};
